




































































import Vue from 'vue'
import { mapGetters } from "vuex";
import { Component, Watch } from "vue-property-decorator";


export type TStepperInfo = {
  step: number;
  title: string;
  description: string;
}


@Component({
  name: "common-widget-infobar",
  computed: {
    ...mapGetters('testing', {
      step: 'step',
      stopDemo: 'stopDemo'
    })
  }
})
export default class CommonWidgetInfobar extends Vue{
  @Watch('step')
  onStepChanged(val: number) {
    if(val === 4) {
      this.$router.push({name: 'ShardList'}).catch(() => {})
    } else if (val === 5) {
      this.$router.push({name: 'Statistics'}).catch(() => {})
    } else if (val === 6) {
      this.$router.push({name: 'Testing'}).catch(() => {})
    }
  }


  step!: 0;
  stopDemo!: false;

  protected data: Array<TStepperInfo> = [
    {
      step: 1,
      title: "Скачайте приложение",
      description: 'Наше приложение доступно в AppStore и Google Play или вы можете скачать установочный файл с нашего сайта по QR-коду - Выберите подходящий вашему устройству QR-код, наведите камеру и начните загрузку'
    },
    {
      step: 2,
      title: "Регистрация",
      description: 'После запуска приложения, вам нужно будет отсканировать свой бейдж. Для этого отлично подойдут тестовые данные, которые вы найдете во 2 шаге нашего демо-тура'
    },
    {
      step: 3,
      title: "Скачайте приложение",
      description: 'Отсканируйте бейджи посетителей, добавьте к ним заметки и составьте анкету'
    },
    {
      step: 4,
      title: "Просмотрите собранные данные",
      description: 'Вы сможете просмотреть все собранные данные, которые вы отсканировали на выставке'
    },
    {
      step: 5,
      title: "Просмотрите собранные данные",
      description: 'В этом разделе вы можете оценить эффективность стендистов вашей компании и сравнить эту активность с другими участниками выставки (или организациями)'
    },
    {
      step: 6,
      title: "Просмотрите собранные данные",
      description: 'Вы можете изменить данные своего аккаунта или стенда и создать вопросы для анкеты'
    },
    {
      step: 7,
      title: "Просмотрите собранные данные",
      description: 'Вы прошли все шаги демо-тура по сервису, на этом этапе вы можете удалить собранные данные и завершить его'
    },
  ]

  private emptyStep:TStepperInfo = { step:0, title: '', description: ''}


  get title(): string {
    const row: TStepperInfo = this.data.find((info: TStepperInfo) => info.step === this.step) || this.emptyStep;
    return row.title || ''
  }
  get description(): string {
    const row: TStepperInfo = this.data.find((info: TStepperInfo) => info.step === this.step) || this.emptyStep;;
    return row.description || ''
  }

  cancel() {
    this.$store.dispatch('testing/cancelStopDemo')
  }
  stop() {
    this.$store.dispatch('testing/stop')
  }
  nextStep() {
    this.$store.dispatch('testing/nextStep')
  }
  stopDemoRequest() {
    this.$store.dispatch('testing/stopDemo')
  }

}
